import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './NewsSourcesPage.css';

const baseUrl = process.env.REACT_APP_NCLUDE_API;

function NewsSourcesPage() {
    const { language } = useParams();
    const navigate = useNavigate();

    const [selectedLanguage, setSelectedLanguage] = useState('Hindi');
    const [newsSources, setNewsSources] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showLoadMore, setShowLoadMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const booksPerPage = 10;

    // Fetch books on component mount
    useEffect(() => {
        if (language) {
            if (language.toLowerCase() == 'hindi') {
                setSelectedLanguage('hin');
            }
            else {
                setSelectedLanguage('eng');
            }
        }
        
        fetchNewsSources();     
    }, [language]);
    
    async function fetchNewsSources() {
        setCurrentPage(1);
        try {
            setLoading(true);
            setError(null);
            
            let response = await axios.get(`${baseUrl}/v1/api/news/news-sources`);
            const data = await response.data;

            if (language.toLowerCase() == 'hindi') {
                setNewsSources(data.hin);
            }
            else {
                setNewsSources(data.eng);
            }

            setShowLoadMore(false);
        }
        catch (err) {
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <div className='container'>
                <section className="header-wrap d-flex justify-content-start align-items-center">
                    <button onClick={() => { navigate(-1); }} className="btn btn-secondary">
                        Go Back
                    </button>
                    <h1 className="logo my-auto ms-4">
                        <span className="assistive-text">Shravan Audiobooks Library</span>
                    </h1>
                </section>
                {
                newsSources != null && newsSources.length > 0 ?
                    (
                        <section className="audiobooks-container mt-5">
                            <div className="audio-book-feed justify-content-start align-items-center" id="secondary-content">
                                <header>
                                    <h3 className="title text-start">Select a News Source</h3>
                                </header>
                                <ul className='list-group audiobooks-list mt-3'>
                                    {
                                        newsSources.map((newsSource, index) => (
                                            <li key={newsSource}
                                                className='list-group-item audiobook-item'>
                                                <Link style={{ textDecoration: 'none', color: 'inherit' }}
                                                    to={`/category/${language}/news/${newsSource}/categories`}
                                                >
                                                    <div className="result-data d-flex justify-content-start align-items-baseline">
                                                        <p className='mb-0'>{index + 1}. {newsSource}</p>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </section>
                    ) :
                    <div className="empty-container mt-5">
                        {
                            newsSources && newsSources.length == 0 ?
                            (
                                <p className='d-flex text-left'>No news sources found</p>
                            )
                            : ( <p></p> )              
                        }
                       
                    </div>
            }

            </div>
        </div>
    );
}

export default NewsSourcesPage;
